const { Component } = require('react')
const PropTypes = require('prop-types')
const ProductListAlternative = require('app/components/products/ProductListAlternative')
const Link = require('app/components/mixins/Link')
const ScrollBooster = require('scrollbooster').default

class PopularProductsAlternative extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      subtitle: PropTypes.string,
      items: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      title: translate('Mest Populære'),
      subtitle: translate('udvalg'),
      items: []
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      activeGroup: 0
    }
  }

  componentDidMount() {
    const productLists = document.querySelectorAll('.product-list')

    for (let i = 0; i < productLists.length; i++) {
      const list = productLists[i]

      const sb = new ScrollBooster({
        viewport: list,
        content: list,
        scrollMode: 'native',
        direction: 'horizontal'
      })
    }
  }


  setGroup(index) {
    this.setState({activeGroup: index})
  }

  _groupClickListener(index) {
    return () => {
      // e.preventDefault();
      this.setGroup(index)
    }
  }

  renderGroupTriggers () {
    return this.props.items.map((item, i) => {
      const className = i === this.state.activeGroup ? 'active' : ''
      return (
        <Link key={i} className={className} href='#' onClick={this._groupClickListener(i)}>{item.title}</Link>
      )
    })
  }

  renderGroups () {
    return this.props.items.map((item, i) => {
      const classList = ['group']
      const groupTitle = i === 0 ? this.props.title : item.title

      if (i === this.state.activeGroup) {
        classList.push('active')
      }

      return (
        <div key={i} className={classList.join(' ')}>
          <h2>{groupTitle}</h2>
          <ProductListAlternative items={item.items} title={groupTitle} />
        </div>
      )
    })
  }

  render () {
    return (
      <div className='grouped-list popular-products'>
        <div className='header'>
          <div className='title'>
            <div className='subtitle'>{this.props.subtitle}</div>
            <h2>{this.props.title}</h2>
          </div>
          <div className='group-toggles'>{this.renderGroupTriggers()}</div>
        </div>
        <div className='body'>{this.renderGroups()}</div>
      </div>
    )
  }
}

module.exports = PopularProductsAlternative
